import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Produkt from "./Pages/Produkt";
import About from "./Pages/About";
import Login from "./Pages/Login";

function App() {
  return (
    <Router>  
      <Switch>  
        <Route path='/' component={Produkt} exact />
        <Route path='/about' component={About} exact />
        <Route path='/login' component={Login} exact />
      </Switch>
    </Router>
  );
}

export default App;